import { getFormattedThousand } from "@datassential/platform-ui-lib";
import TopicsAndOpenEnds from "@pages/ItemDetails/parts/CardOpenEndedFeedback/TopicsAndOpenEnds";
import { components } from "@api/api";
import { FC, memo } from "react";

export type Topic = components["schemas"]["AiTopicModel"];
export type OpenEnd = components["schemas"]["FilteredOpenEndDto"];

const LikesAndDislikes: FC<{
    likeTopics: Topic[];
    dislikeTopics: Topic[];
    likeOpenEnds: OpenEnd[];
    dislikeOpenEnds: OpenEnd[];
    baseSize: number;
}> = ({
    likeTopics,
    dislikeTopics,
    likeOpenEnds,
    dislikeOpenEnds,
    baseSize,
}) => {
    return (
        <div className="CardOpenEndedFeedback__section">
            <div className="CardOpenEndedFeedback__section-header">
                <span className="CardOpenEndedFeedback__section-title">
                    LIKES AND DISLIKES
                </span>
                <span className="CardOpenEndedFeedback__section-subtitle">
                    (n={getFormattedThousand(baseSize ?? 0)}) | click any like or dislike to filter
                </span>
            </div>
            <div
                className="CardOpenEndedFeedback__section-content"
                style={{ height: 320 }}
            >
                <TopicsAndOpenEnds
                    topics={likeTopics}
                    openEnds={likeOpenEnds}
                    isLike
                />
                <div className="CardOpenEndedFeedback__separator"/>
                <TopicsAndOpenEnds
                    topics={dislikeTopics}
                    openEnds={dislikeOpenEnds}
                />
            </div>
        </div>
    );
};

export default memo(LikesAndDislikes);